<ng-container *ngIf="!!user; else loadingTemplate">
  <ng-container *ngIf="link; else noLinkTemplate">
    <a [href]="url" (click)="openGallery()" astrobinEventPreventDefault>
      <ng-container [ngTemplateOutlet]="imageTemplate"></ng-container>
    </a>
  </ng-container>

  <ng-template #noLinkTemplate>
    <ng-container [ngTemplateOutlet]="imageTemplate"></ng-container>
  </ng-template>

  <ng-template #imageTemplate>
    <div class="avatar-wrapper">
      <img [alt]="user.username" [src]="avatarUrl" />

      <div
        *ngIf="showEditButton && isCurrentUser"
        [ngbTooltip]="'Edit avatar' | translate"
        class="edit-button"
        container="body"
      >
        <button (click)="openAvatarEditor($event)" class="btn btn-sm">
          <fa-icon icon="pencil"></fa-icon>
        </button>
      </div>

      <div class="badges">
        <div
          *ngIf="showPremiumBadge && user?.validSubscription"
          @fadeInOut
          [ngbTooltip]="'Supporting member' | translate"
          class="badge badge-premium"
          container="body"
        >
          <fa-icon icon="asterisk"></fa-icon>
        </div>

        <div
          *ngIf="showFollowsYouBadge && followsYou"
          @fadeInOut
          [ngbTooltip]="'Follows you' | translate"
          class="badge badge-follows-you"
          container="body"
        >
          <fa-icon icon="person-walking-arrow-right"></fa-icon>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
